import { QueryParams } from "@/models/query-params.model";
import { GeneralInfo } from "@/models/stats.model";
import { ObjectivesRest } from "@/services/rest/objectives.rest";
import { StatsRest } from "@/services/rest/stats.rest";
import { BehaviorSubject, Observable, take } from "rxjs";

export class GeneralService {
  private classroomId: string | undefined;

  constructor(
    private _stats = new StatsRest(),
    private _objective = new ObjectivesRest()
  ) {
    this.classroomId = localStorage.getItem("objClassroomId") ?? undefined;
  }

  private general$: BehaviorSubject<any> = new BehaviorSubject<GeneralInfo>(
    new GeneralInfo()
  );
  general: Observable<GeneralInfo> = this.general$.asObservable();
  objectives$ = new BehaviorSubject([]);
  objectives = this.objectives$.asObservable();

  static objective$ = new BehaviorSubject({
    courseId: "",
    objectiveId: "",
    objectiveName: "",
  });
  static objective = this.objective$.asObservable();

  getGeneralFromObjective(courseId: string): void {
    this._stats
      .getGeneralFromObjective(courseId, { classroomId: this.classroomId })
      .subscribe({
        next: (response) => {
          this.general$.next(response);
        },
      });
  }

  getAllObjectivesByCourse(params: Partial<QueryParams>): void {
    this._objective
      .getAllObjectivesByCourse({ ...params, classroomId: this.classroomId })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.objectives$.next(response);
        },
      });
  }

  static setObjective(value: {
    courseId: string;
    objectiveId: string;
    objectiveName: string;
  }): void {
    this.objective$.next(value);
  }
}
